import { bindActionCreators } from "redux"
import { connect } from "react-redux"

// action creators
import UrlStatusMessage from "./UrlStatusMessage"

export { getErrorMessageType } from "./UrlStatusMessage"

export const mapDispatchToProps = (dispatch) => ({
  reduxActions: bindActionCreators({}, dispatch),
})

export const mapStateToProps = (state) => {
  const { cloudCraze, customerSelections, userAccount } = state

  return {
    reduxState: {
      cloudCraze,
      customerSelections,
      userAccount,
    },
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(UrlStatusMessage)
